import { render, staticRenderFns } from "./exhibitionList.vue?vue&type=template&id=cb14c35e&scoped=true&"
import script from "./exhibitionList.vue?vue&type=script&lang=js&"
export * from "./exhibitionList.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionList.vue?vue&type=style&index=0&id=cb14c35e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb14c35e",
  null
  
)

export default component.exports